<template>
  <div>
    <h4>Invoice Info Spreadsheet.</h4>
    <div class="text-center">
      <button class="btn btn-warning mr-3" @click="$emit('done')">Cancel</button>
      <button v-if="ready && !error" class="btn btn-success" @click="download()">Download</button>
      <button v-if="!ready && !error" class="btn" disabled>
        Preparing...
        <i class="fa fa-spin fa-spinner"></i>
      </button>
      <div v-if="error" class="text-danger pt-3">{{error}}</div>
    </div>
  </div>
</template>

<script>
import XLSX from "xlsx";
import SpreadsheetUtils from "@/spreadsheet-utils";

export default {
  name: "all-nodes-spreadsheet",
  components: {},
  props: ["company"],
  data: () => ({
    ready: false,
    error: "",
    workbook: {}
  }),
  methods: {
    downloadData: async function() {
      try {
        let start = new Date();

        const response = await this.$web.getInvoiceData(this.company.id);

        let ws = SpreadsheetUtils.createInvoiceWorksheet(response.data);
        this.workbook = SpreadsheetUtils.createWorkbook(
          [ws],
          [this.company.name]
        );

        this.$utils.minWait(() => (this.ready = true), start, 500);
      } catch (err) {
        console.log(err);
        this.error = "An error occurred.";
      }
    },
    download: function() {
      SpreadsheetUtils.downloadWorkbook(this.workbook, this.company.name);
      this.$emit("done");
    }
  },
  async mounted() {
    this.downloadData();
  }
};
</script>

<style scoped>
.btn:disabled {
  cursor: wait;
}
</style>
